<ng-container *ngIf="options" [formGroup]="formGroup">
  <mat-button-toggle-group
    [hideSingleSelectionIndicator]="true"
    *ngFor="let option of options; trackBy: 'id' | trackBy"
    [formControlName]="option.name"
  >
    <mat-button-toggle
      *ngFor="let value of option.values; trackBy: 'id' | trackBy"
      [checked]="getControlByName(option.name)?.value?.id === value.id"
      [value]="{ optionId: option.id, id: value.id }"
    >
      {{ value.name }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</ng-container>
